// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1SUOv","content":"LoadingAlert_content__1coC1"};